import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  title?: string;
  className?: string;
  active?: boolean;
  padded?: boolean;
}

export function Panel({ children, title, className = "", active = false, padded = true }: Props) {
  return (
    <div
      className={`${active ? "border-terminal" : "border-border"} border bg-surface ${className}`}
    >
      {title && (
        <div className="border-b border-border px-4 py-2 flex items-center justify-between">
          <span className="terminal-label">{title}</span>
        </div>
      )}
      <div className={padded ? "p-5" : ""}>{children}</div>
    </div>
  );
}